import { type ResourcesConfig } from 'aws-amplify'

export const authConfig: ResourcesConfig['Auth'] = {
  Cognito: {
    userPoolId: String(process.env.NEXT_PUBLIC_USER_POOL_ID),
    userPoolClientId: String(process.env.NEXT_PUBLIC_USER_POOL_WEB_CLIENT_ID),
    identityPoolId: String(process.env.NEXT_PUBLIC_IDENTITY_POOL_ID),
    allowGuestAccess: true,

    loginWith: {
      oauth: {
        domain: process.env.NEXT_PUBLIC_DOMAIN ?? '',
        scopes: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: [process.env.NEXT_PUBLIC_WEBSITE_URL + '/login/confirm'],
        redirectSignOut: [process.env.NEXT_PUBLIC_WEBSITE_URL ?? ''],
        responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
      },
    },
  },
}
